import { requestService, useRequestStore } from "entities/Request";
import { useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Button } from "shared/ui";

function ReasonOfOnHoldModal({ handleClose, show, triggerMutation }) {
  const { t } = useTranslation("Request");
  const request = useRequestStore((state) => state.request);
  const [isToggling, setIsToggling] = useState(false);
  const [comment, setComment] = useState("");

  const handleOnHoldSet = () => {
    setIsToggling(true);
    requestService
      .setOnHold({
        application_id: request.id,
        comment,
      })
      .then((onHold) => {
        triggerMutation(null, {
          optimisticData: (current) => ({
            ...current,
            onHold: {
              data: onHold,
            },
          }),
        });
        handleClose();
      })
      .finally(() => setIsToggling(false));
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t("on_hold.modal_title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
          <Form.Label>{t("on_hold.comment_label")}</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={comment}
            maxLength={50}
            onChange={(e) => setComment(e.target.value)}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" onClick={handleClose}>
          {t("buttons.close")}
        </Button>
        <Button
          variant="primary"
          onClick={handleOnHoldSet}
          disabled={!comment.length || isToggling}
          isLoading={isToggling}
        >
          {t("buttons.save")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ReasonOfOnHoldModal;
